import React from 'react';
import ProfileImageField from './ProfileImageField';

const Field = ({ label, optional, children }) => (
    <label className="block space-y-2">
        <span className="text-xs font-medium text-zinc-600 dark:text-zinc-400">
            {label}
            {optional ? (
                <span className="font-normal text-zinc-400"> (optional)</span>
            ) : null}
        </span>
        {children}
    </label>
);

const CompanyProfileFormFields = ({
    form,
    onChange,
    inputClass,
    backendToken,
    ownerWallet = '',
    disabled = false,
}) => {
    const setField = (name, value) => {
        onChange({ target: { name, value } });
    };

    return (
        <div className="space-y-5">
            <ProfileImageField
                label="Company logo"
                value={form.profileImageUrl}
                onChange={(url) => setField('profileImageUrl', url)}
                walletAddress={ownerWallet}
                backendToken={backendToken}
                disabled={disabled}
            />

            <div className="grid gap-4 sm:grid-cols-2">
                <Field label="Company name">
                    <input
                        type="text"
                        name="name"
                        required
                        value={form.name}
                        onChange={onChange}
                        placeholder="CronPay Labs"
                        className={inputClass}
                        disabled={disabled}
                    />
                </Field>
                <Field label="Team size" optional>
                    <input
                        type="text"
                        name="employeeSize"
                        value={form.employeeSize}
                        onChange={onChange}
                        placeholder="11–50"
                        className={inputClass}
                        disabled={disabled}
                    />
                </Field>
                <Field label="Email" optional>
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={onChange}
                        placeholder="team@company.com"
                        className={inputClass}
                        disabled={disabled}
                    />
                </Field>
                <Field label="Website" optional>
                    <input
                        type="url"
                        name="website"
                        value={form.website}
                        onChange={onChange}
                        placeholder="https://company.com"
                        className={inputClass}
                        disabled={disabled}
                    />
                </Field>
                <Field label="Industry" optional>
                    <input
                        type="text"
                        name="industry"
                        value={form.industry}
                        onChange={onChange}
                        placeholder="Software, Agency, Finance…"
                        className={inputClass}
                        disabled={disabled}
                    />
                </Field>
                <Field label="Location" optional>
                    <input
                        type="text"
                        name="location"
                        value={form.location}
                        onChange={onChange}
                        placeholder="City, Country"
                        className={inputClass}
                        disabled={disabled}
                    />
                </Field>
            </div>

            <Field label="About the company" optional>
                <textarea
                    name="description"
                    rows={3}
                    value={form.description}
                    onChange={onChange}
                    placeholder="What does your organization do? Who do you hire?"
                    className={`${inputClass} resize-y min-h-[88px]`}
                    disabled={disabled}
                />
            </Field>
        </div>
    );
};

export default CompanyProfileFormFields;
